import { css } from '@emotion/react'
import Input from '@src/components/inputs/Input'
import styled from '@emotion/styled'

// import useSignup from '@src/hooks/auth/signup/useSignup'
import useSignupContext from '@src/hooks/auth/signup/useSignupContext'
import { Checkbox } from 'antd'

const ContactInfoSection = () => {
	const {
		contactsFields,
		handleAddVendorContact,
		handleRemoveVendorContact,
		handleClickCopyCeoInfoToFillContactInfo,
		getFieldProps,
	} = useSignupContext()

	return (
		<div>
			<CopyCheckBox onChange={handleClickCopyCeoInfoToFillContactInfo}>
				대표자 정보와 동일
			</CopyCheckBox>
			{contactsFields.map((field, index) => {
				return (
					<ContactInfoBlock key={field.id}>
						<Input
							{...getFieldProps(`vendorContacts.${index}.name`)}
							css={inputStyle}
							label="담당자명"
							placeholder="담당자명을 입력해주세요."
						/>
						<Input
							{...getFieldProps(`vendorContacts.${index}.position`)}
							css={inputStyle}
							label="직책"
							placeholder="직책을 입력해주세요."
						/>
						<Input
							{...getFieldProps(`vendorContacts.${index}.email`)}
							css={inputStyle}
							label="담당자 이메일"
							placeholder="담당자 이메일을 입력해주세요."
						/>
						<Input
							{...getFieldProps(`vendorContacts.${index}.phone`)}
							css={inputStyle}
							label="담당자 연락처"
							placeholder="담당자 연락처를 입력해주세요."
						/>
						{index !== 0 ? (
							<RemoveButton type="button" onClick={() => handleRemoveVendorContact(index)}>
								삭제
							</RemoveButton>
						) : null}
					</ContactInfoBlock>
				)
			})}
			<AddButton type="button" onClick={handleAddVendorContact}>
				담당자 추가
			</AddButton>
		</div>
	)
}

const ContactInfoBlock = styled.div`
	position: relative;
	border: 1px solid #e7e7ed;
	padding: 2rem;
	margin-top: 1rem;
	border-radius: 0.5rem;
`

const inputStyle = css`
	width: 27rem;
`

const buttonStyle = css`
	font-size: 1.4rem;
	line-height: 2.4rem;
	font-weight: 600;
	text-align: center;
	height: 4rem;
	padding: 0 1.6rem;
	background-color: #fff;
	border: 1px solid #e7e7ed;
	color: #363644;
	cursor: pointer;
`

const AddButton = styled.button`
	${buttonStyle}
	margin-top: 2.2rem;
`

const RemoveButton = styled.button`
	${buttonStyle}
	position: absolute;
	right: 2rem;
	bottom: 2rem;
`

const CopyCheckBox = styled(Checkbox)`
	.ant-checkbox-checked .ant-checkbox-inner {
		background-color: #000;
		border-color: #000;
	}
`

export default ContactInfoSection
